import React__default from 'react';
import { SvgImg } from '../../components/svgImg/svgImg.js';

const RightArrow = ({ width = '12', height = '12', fill = '#929292' }) => {
    return (React__default.createElement(SvgImg, { width: width, height: height, title: "waiting", viewbox: "0 0 12 12" },
        React__default.createElement("g", { id: "ICON" },
            React__default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6 0L5.293 0.707L10.086 5.5H0V6.5H10.086L5.293 11.293L6 12L12 6L6 0Z", fill: fill }))));
};

export { RightArrow };
